import { FC, useState } from 'react';
import { PatientNameDataFragment } from '../../../../../../generated/graphql';
import Avatar from '../../../../Avatar';
import Button from '../../../../Button';

interface PatientRowProps {
  patient: PatientNameDataFragment;
  handleRemovePatientFromProviderUser: (programId: any) => Promise<void>;
}

const PatientRow: FC<PatientRowProps> = ({
  patient,
  handleRemovePatientFromProviderUser,
}) => {
  const [isRemoving, setIsRemoving] = useState(false);

  const handleOnClickRemovePatient = async () => {
    try {
      setIsRemoving(true);
      await handleRemovePatientFromProviderUser(patient.programInstanceId);
    } catch (err) {
      console.log(err);
    } finally {
      setIsRemoving(false);
    }
  };

  return (
    <div className="flex h-[48px] w-full flex-row items-center justify-between text-caption text-green-150">
      <div className="flex flex-row items-center gap-x-4">
        <Avatar
          imageUrl={patient.profileImageMedia?.url}
          name={patient.firstName}
          size="medium"
        />
        <div className="flex flex-col items-start justify-start font-serif text-extra-small text-green-150">
          <div>
            {patient.firstName} {patient.lastName}
          </div>
        </div>
      </div>

      <Button
        size="smaller"
        title={!isRemoving ? 'Remove' : 'Removing...'}
        disabled={isRemoving}
        noFocus
        theme="primary"
        onClick={handleOnClickRemovePatient}
      />
    </div>
  );
};

export default PatientRow;
